import { renderBylineContent, renderSeeMoreContent } from '../../../shared/sections/section8_byline.js'

export const bylineHandler = {
  property: 'data-background-byline',
  load: (card) => {
    const elem = document.createElement('div')

    elem.setAttribute('style', `background-color: #06090a; background-size: cover; background-position-x: center;`)
    elem.id = card.getAttribute('data-background-id')
    //elem.innerHTML = renderSeeMoreContent()
    return elem
  }
}

export const seeMoreHandler = {
  property: 'data-background-see-more',
  load: (card) => {
    const elem = document.createElement('div')

    elem.setAttribute('style', `background-color: #06090a; background-size: cover; background-position-x: center;`)
    elem.id = card.getAttribute('data-background-id')
    //elem.innerHTML = renderBylineContent()
    return elem
  }
}



// WEBPACK FOOTER //
// ./src/client/sections/byline/index.js